/** @format */

import axios from "axios";
import Carousel from "react-multi-carousel";
import React, { useEffect, useState } from "react";
import { FilterOutlined } from "@ant-design/icons";
import { useOutletContext } from "react-router-dom";

import "../../../units";
import Balanslar from "./Balanslar";
import Chart2 from "../../../../republik/components/Chart2";
import Chart3 from "../../../../republik/components/Chart3";
import Chart4 from "../../../../republik/components/Chart4";
import Chart5 from "../../../../republik/components/Chart5";
import Chart6 from "../../../../republik/components/Chart6";
import Chart7 from "../../../../republik/components/Chart7";
import { header } from "../../../../../components/api/Header";
import Chart11 from "../../../../republik/components/Chart11";
import Chart10 from "../../../../republik/components/Chart10";
import Suvomborlar from "../../../../republik/pages/Dashboard/SuvOmborlar";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

const BoshSahifa = ({ date }) => {
  const [data, setData] = useState([]);
  const [collapsed] = useOutletContext();
  const [loading, setLoading] = useState(false);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 8,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/dashboard/charts?date=" +
            date,
          header()
        );
        if (res) {
          setData(res.data);
        }
      } catch (e) {
        console.log("Xato", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='dashboard'>
      {loading ? (
        <LoadingCard loading={loading} heightSize='40vh' />
      ) : (
        <>
          <div className='data-content mt-1 bosh-sahifa'>
            <Balanslar date={date} />
            <Suvomborlar date={date} />
          </div>

          {/* <div className='data-content card3 mt-3'>
            <div className='card statistic-card bosh-sahifa-barchart px-2'>
              <Chart11 />
            </div>
            <div className='card statistic-card bosh-sahifa-barchart px-2'>
              <Chart10 />
            </div>
          </div> */}

          <div className='mgk-box'>
            <div className='data-content mt-3'>
              <div
                className='card statistic-card px-3'
                style={
                  collapsed
                    ? { width: `calc(${window.innerWidth + "px"} - 473px)` }
                    : { width: `calc(${window.innerWidth + "px"} - 655px)` }
                }>
                <h4 className='statics4-title'>ASOSIY MANBALAR</h4>
                <Carousel
                  responsive={responsive}
                  infinite={true}
                  autoPlay={true}
                  containerClass='carousel-container'
                  renderArrowsWhenDisabled={true}
                  removeArrowOnDeviceType='desktop'
                  autoPlaySpeed='10000'>
                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["645"]
                            ? data["m"]["645"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>sm</span>
                      </h3>

                      <p>Termiz g/p </p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["5"]
                            ? data["m"]["5"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Amu Zang n/s</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["67"]
                            ? data["m"]["67"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>QMK</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["110"]
                            ? data["m"]["110"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>ABMK</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["677"]
                            ? data["m"]["677"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Tuyamuyun (O'ng qir.)</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["678"]
                            ? data["m"]["678"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Tuyamuyun (Chap qir.)</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["679"]
                            ? data["m"]["679"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Turkmandaryo</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["169"]
                            ? data["m"]["169"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Taxiatosh G/U</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["208"]
                            ? data["m"]["208"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Eski Tuyatortar (Jizzax)</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["209"]
                            ? data["m"]["209"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Eski Anhor (Qashqadaryo)</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["240"]
                            ? data["m"]["240"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Xazara g/p</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["308"]
                            ? data["m"]["308"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>KNK</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["312"]
                            ? data["m"]["312"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>SHFK</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["313"]
                            ? data["m"]["313"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>SHFK (Tojikiston)</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["324"]
                            ? data["m"]["324"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>
                        Zardaryo <span className='lower'>k-l</span>.
                      </p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["463"]
                            ? data["m"]["463"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Eski boshi </p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["464"]
                            ? data["m"]["464"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>KDP boshi </p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["465"]
                            ? data["m"]["465"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>BАK</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["466"]
                            ? data["m"]["466"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Kuyganyor G/U</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["472"]
                            ? data["m"]["472"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>1-2 boʼlim chegarasi </p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["478"]
                            ? data["m"]["478"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>BFK (Tojikiston) </p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["292"]
                            ? data["m"]["292"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Andijon SO (chiqishi)</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["298"]
                            ? data["m"]["298"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>
                      <p>Savay</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["299"]
                            ? data["m"]["299"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Andijonsoy</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["300"]
                            ? data["m"]["300"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>
                      <p>Shahrixonsoy</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["301"]
                            ? data["m"]["301"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>
                      <p>JFMK</p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["277"]
                            ? data["m"]["277"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Teshiktosh G/U</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["414"]
                            ? data["m"]["414"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>
                        Doʼstlik <span className='lower'>k-l</span>.
                      </p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["417"]
                            ? data["m"]["417"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>JMMK</p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["419"]
                            ? data["m"]["419"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>
                        DGNS <span className='lower'>n/s</span>
                      </p>
                    </div>
                  </div>

                  <div>
                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["373"]
                            ? data["m"]["373"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Gʼazalkent GES chiqishi </p>
                    </div>

                    <div className='statics4-box-inner text-center'>
                      <h3>
                        {data["m"]
                          ? data["m"]["373"]
                            ? data["m"]["373"]["suvi"]
                            : "-"
                          : "-"}{" "}
                        <span className='lower'>
                          m<sup>3</sup>/s
                        </span>
                      </h3>

                      <p>Gʼazalkent GES (boshqa) </p>
                    </div>
                  </div>
                </Carousel>
              </div>
            </div>

            <div className='data-sug mt-3'>
              <div className='card statistic-card px-2 pt-0'>
                <h4 className='statics4-title text-center'>
                  <span>
                    Sug'orilgan maydon <span className='lower'>(ming.ga)</span>
                  </span>
                </h4>

                <ul className='lists'>
                  <li className='w-100'>
                    <div className='head tex justify-content-center'>
                      <h3 className='text-center'>
                        <FilterOutlined
                          style={{ fontSize: "18px", color: "#1BCB80" }}
                        />
                        Jami: 1 115
                      </h3>
                    </div>
                  </li>
                </ul>

                <ul className='lists sugorish'>
                  <li>
                    <div className='head'>
                      <h3>1 210</h3>
                      <p>Paxta maydoni</p>
                    </div>

                    <div
                      className='vertical-line'
                      style={{ backgroundColor: "#FF6060" }}></div>
                  </li>

                  <li>
                    <div className='head'>
                      <h3>1 115</h3>
                      <p>G'alla maydoni</p>
                    </div>

                    <div
                      className='vertical-line'
                      style={{ backgroundColor: "#FF6060" }}></div>
                  </li>

                  <li>
                    <div className='head'>
                      <h3>1 210</h3>
                      <p>Tomorqa va boshqa</p>
                    </div>

                    <div
                      className='vertical-line'
                      style={{ backgroundColor: "#FF6060" }}></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}

      {loading ? (
        <LoadingCard loading={loading} heightSize='40vh' />
      ) : (
        <div className='data-content mt-3 data-content-footer'>
          <Chart2 data={data["r"]} />
          <Chart7 data={data["re"]} />
          <Chart3 data={data["o"]} />
          <Chart5 data={data["z"]} />
          <Chart4 data={data["t"]} />
          <Chart6 data={data["q"]} />
        </div>
      )}
    </div>
  );
};

export default BoshSahifa;
